var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 161,
    viewBox: "0 0 160 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2406 43.9285C10.6796 43.9285 3.93971 50.7242 4.61855 58.6717L8.55691 104.506C9.16571 111.602 15.5285 117.071 23.1789 117.071H136.82C144.465 117.071 150.828 111.602 151.442 104.506L155.381 58.6717C156.065 50.7297 149.32 43.9285 140.759 43.9285H19.2406Z",
    fill: "#CCE2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2134 44.9457L102.453 34.3229C102.585 34.3 102.716 34.2886 102.848 34.2886C103.95 34.2886 104.888 35.0771 105.082 36.1629L108.596 56.0771C108.699 56.6771 108.556 57.3057 108.196 57.7971L103.076 64.8886C102.688 65.4314 102.499 66.1 102.545 66.7629L47.7562 76.4257L42.2076 44.9457H42.2134Z",
    fill: "#7A9CCB",
    stroke: "#215AA8",
    strokeWidth: 1.14286
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3277 119.443C59.7106 119.443 57.4763 117.569 57.0192 114.98L45.402 49.0943C44.8877 46.1629 46.8477 43.3572 49.7792 42.8429L79.6934 37.5686L106.871 57.2143L115.248 104.717C115.762 107.649 113.802 110.454 110.871 110.969L63.2706 119.357C62.9563 119.414 62.642 119.443 62.3277 119.443Z",
    fill: "#7A9CCB",
    stroke: "#215AA8",
    strokeWidth: 1.14286
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6648 59.4142C86.2534 59.4142 84.1962 57.6885 83.7734 55.3056L80.7848 38.3513L105.842 56.4656L89.5334 59.3399C89.2476 59.3913 88.9562 59.4142 88.6648 59.4142Z",
    fill: "#D3DEEE",
    stroke: "#215AA8",
    strokeWidth: 1.14286
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.642 123.929C51.4991 123.929 50.5277 123.112 50.3334 121.986L36.922 45.9458C36.8134 45.3287 36.9505 44.7058 37.3105 44.1915C37.6705 43.6772 38.2077 43.3344 38.8305 43.2258L96.202 33.1058C96.3391 33.083 96.4763 33.0715 96.6134 33.0715C97.7563 33.0715 98.7277 33.8887 98.9277 35.0144L112.333 111.054C112.556 112.329 111.705 113.552 110.425 113.78L53.0534 123.894C52.9163 123.917 52.7791 123.929 52.642 123.929Z",
    fill: "#A6BDDC",
    stroke: "#215AA8",
    strokeWidth: 1.14286
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.959 90.2907L77.3552 94.6289C76.6373 94.7555 76.1579 95.4402 76.2845 96.1581L78.8128 110.497C78.9394 111.215 79.6241 111.694 80.342 111.568L104.945 107.229C105.663 107.103 106.143 106.418 106.016 105.7L103.488 91.3614C103.361 90.6435 102.676 90.1641 101.959 90.2907Z",
    fill: "#4D7BB9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0077 128.449C46.3905 128.449 44.1562 126.574 43.6991 123.986L32.0819 58.1002C31.5677 55.1687 33.5277 52.363 36.4591 51.8487L66.3734 46.5745L93.5505 66.2202L101.928 113.723C102.179 115.14 101.859 116.574 101.036 117.757C100.208 118.94 98.9734 119.723 97.5562 119.974L49.9562 128.363C49.6419 128.42 49.3277 128.443 49.0134 128.443L49.0077 128.449Z",
    fill: "white",
    stroke: "#215AA8",
    strokeWidth: 1.14286
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M75.3505 68.42C72.939 68.42 70.8819 66.6943 70.459 64.3115L67.4705 47.3572L92.5276 65.4715L76.219 68.3457C75.9333 68.3972 75.6419 68.42 75.3505 68.42Z",
    fill: "#D3DEEE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3505 68.42C72.939 68.42 70.8819 66.6943 70.459 64.3115L67.4705 47.3572L92.5276 65.4715L76.219 68.3457C75.9333 68.3972 75.6419 68.42 75.3505 68.42Z",
    stroke: "#215AA8",
    strokeWidth: 1.14286
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M119.834 75.0714C130.656 75.0714 139.429 66.2987 139.429 55.4771C139.429 44.6555 130.656 35.8828 119.834 35.8828C109.013 35.8828 100.24 44.6555 100.24 55.4771C100.24 66.2987 109.013 75.0714 119.834 75.0714Z",
    fill: "#0045A3"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M117.88 73.117C128.702 73.117 137.474 64.3444 137.474 53.5228C137.474 42.7011 128.702 33.9285 117.88 33.9285C107.058 33.9285 98.2856 42.7011 98.2856 53.5228C98.2856 64.3444 107.058 73.117 117.88 73.117Z",
    fill: "#3378D6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M117.88 59.3113C116.789 59.3113 115.903 58.4256 115.903 57.3342V54.0713C115.903 52.9799 116.789 52.0942 117.88 52.0942C119.491 52.0942 120.806 50.7856 120.806 49.1685C120.806 47.5513 119.497 46.2428 117.88 46.2428C116.263 46.2428 114.954 47.5513 114.954 49.1685C114.954 50.2599 114.069 51.1456 112.977 51.1456C111.886 51.1456 111 50.2599 111 49.1685C111 45.3799 114.086 42.2942 117.874 42.2942C121.663 42.2942 124.749 45.3799 124.749 49.1685C124.749 52.2142 122.749 54.8828 119.851 55.7513V57.3285C119.851 58.4199 118.966 59.3056 117.874 59.3056L117.88 59.3113Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M117.88 64.6142C116.789 64.6142 115.903 63.7285 115.903 62.6371C115.903 61.5456 116.789 60.6599 117.88 60.6599C118.971 60.6599 119.857 61.5456 119.857 62.6371C119.857 63.7285 118.971 64.6142 117.88 64.6142Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.be68ed8cc62816360fa48160c2a82e03.svg";
export { ForwardRef as ReactComponent };